import { render, staticRenderFns } from "./LotViewLotNo.vue?vue&type=template&id=74863b4c&scoped=true&"
import script from "./LotViewLotNo.vue?vue&type=script&lang=js&"
export * from "./LotViewLotNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74863b4c",
  null
  
)

export default component.exports